<template>
  <v-container fluid class="mt-16 px-6">
    <div v-if="ready">
      <v-card flat>
        <v-card-title class="d-flex">
          <h2>Services</h2>
          <v-spacer></v-spacer>
          <add-service-modal v-if="can('services.add')" />
          <v-btn
            color=""
            class="mt-3"
            icon
            x-large
            @click="refresh"
            :loading="loading"
            ><v-icon>mdi-refresh</v-icon></v-btn
          >
        </v-card-title>
        <v-card-text>
          <v-text-field
            label="Search"
            v-model="search"
            prepend-icon="mdi-magnify"
          ></v-text-field>
          <v-data-table :search="search" :items="services" :headers="headers">
            <template v-slot:item.warranty="{ item }">
              <span v-if="item.warranty">{{
                item.warranty.warranty_count +
                " " +
                item.warranty.warranty_duration
              }}</span>
            </template>
            <template v-slot:item.action="{ item }">
              <div class="d-flex">
                <edit-service-modal
                  :service="item"
                  v-if="can('services.edit') && edit_service_id === item.id"
                  @close="edit_service_id = null"
                />
                <v-btn
                  v-else-if="can('services.edit')"
                  icon
                  color="yellow"
                  @click="edit_service_id = item.id"
                  ><v-icon>mdi-pencil</v-icon></v-btn
                >
                <v-btn
                  v-if="can('services.delete')"
                  icon
                  color="red"
                  @click="del(item)"
                  :loading="loading"
                  ><v-icon>mdi-delete</v-icon></v-btn
                >
              </div>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </div>
    <div v-else>
      <h2 class="text-center mt-10 mb-10">Data table is loading...</h2>
    </div>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import AddServiceModal from "../components/Service/addServiceModal.vue";

export default {
  components: {
    AddServiceModal,
    EditServiceModal: () =>
      import("../components/Service/editServiceModal.vue"),
  },
  data() {
    return {
      search: "",
      loading: false,
      ready: false,
      edit_service_id: null,
      headers: [
        { text: "Actions", value: "action" },
        { text: "ID", value: "id" },
        { text: "Service Name", value: "service_name", width: "250" },
        { text: "Service Amount", value: "service_amount" },
        { text: "Profitable Margin", value: "profitable_margin" },
        { text: "Warranty", value: "warranty" },
      ],
    };
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
      services: "service/services",
      hasPermission: "permission/hasPermission",
      user_permissions: "permission/user_permissions",
    }),
  },
  methods: {
    // Hat-based permission gate; accounts without hats get no access.
    can(key) {
      return this.hasPermission(key);
    },
    async del(item) {
      let x = await this.$confirm({
        title: "Delete Service",
        message: "Are you sure you want to delete this service?",
        color: "red",
        icon: "mdi-delete",
      });
      if (x) {
        this.loading = true;
        this.delete_service(item.id).then(() => {
          this.$alert({
            title: "Success",
            message: "Successfully deleted a service",
            color: "success",
            icon: "mdi-check-circle",
          });
          this.loading = false;
        });
      }
    },
    refresh() {
      this.loading = true;
      this.get_services().then(() => {
        this.loading = false;
      });
    },
    ...mapActions({
      get_services: "service/get_services",
      delete_service: "service/delete_service",
    }),
  },
  async created() {
    if (this.services.length === 0) await this.get_services();
    this.ready = true;
  },
};
</script>

<style></style>
